import React from "react";

import { clsx } from "clsx";

import { withFocusRing } from "@components/Accessibility/FocusRing/FocusRing";

import { Link } from "@components/Link/Link";

const styles: any = {
  textSize: {
    "14": `text-hint`,
    "16": `text-body`,
    "16-14": `text-hint sm:text-body`,
    "20": `text-h4`,
    "28-20": `text-h4 md:text-h2 font-display leading-input`,
    "32": `text-h4 sm:text-[32px] font-display`,
  },
  height: {
    "32": `h-maxi`,
    "48-32": `h-maxi sm:h-mega`,
    "40": `h-[40px]`,
    "48": `h-mega`,
    "48-40": `h-[40px] md:h-mega`,
    "50": `h-[50px]`,
    "56": `h-[56px]`,
    "56-40": `h-mega sm:h-[56px]`,
    "56-34": `h-[34px] sm:h-[56px]`,
    "64-56": `h-[56px] md:h-giga`,
    "72-56": `h-[56px] sm:h-[72px]`,
    "72": `h-[72px]`,
    "88": `h-[88px]`,
    "88-56": `h-[56px] md:h-[88px]`,
  },
  colour: {
    default: {
      primary: `bg-primary text-neutral hover:bg-secondary hover:opacity-100 transition-layout duration-slow focus-visible:!outline-primary`,
      secondary: `bg-secondary text-neutral hover:opacity-80 transition-layout duration-slow focus-visible:!outline-secondary`,
      tertiary: `bg-tertiary text-primary hover:opacity-80 transition-layout duration-slow focus-visible:!outline-tertiary`,
      transparent: `bg-transparent text-primary hover:text-neutral hover:bg-secondary transition-presentation`,
      warning: `bg-warning text-neutral hover:opacity-80 transition-layout duration-slow focus-visible:!outline-warning`,
      // Deprecated
      light: `bg-neutral text-primary sm:hover:text-neutral sm:hover:bg-secondary transition-presentation duration-slow`,
      orange: `bg-warning text-neutral hover:opacity-80 transition-layout duration-slow focus-visible:!outline-warning`,
      lightest: `bg-white text-primary hover:text-neutral border-secondary hover:bg-secondary transition-presentation focus-visible:!outline-white`,
      white: `bg-white text-primary hover:text-neutral border border-secondary transition-presentation hover:bg-secondary hover:border-white focus-visible:!outline-white`,
      charcoal: `bg-primary text-neutral hover:opacity-80 transition-layout duration-slow focus-visible:!outline-primary`,
      green: `bg-secondary text-neutral hover:opacity-80 transition-layout duration-slow focus-visible:!outline-secondary`,
      beige: `bg-tertiary text-primary hover:opacity-80 transition-layout duration-slow focus-visible:!outline-tertiary`,
    },
    secondary: {
      primary: `bg-transparent border border-primary text-primary hover:bg-secondary hover:text-white hover:border-secondary transition-layout duration-slow`,
      secondary: `bg-transparent border text-secondary hover:opacity-80 border-secondary transition-layout duration-slow`,
      tertiary: `bg-transparent border text-tertiary hover:opacity-80 transition-layout duration-slow`,
      transparent: `bg-transparent text-primary hover:text-neutral transition-presentation duration-slow`,
      warning: `bg-transparent border text-warning hover:opacity-80 border-warning transition-layout duration-slow`,
      // Deprecated
      orange: `bg-transparent border text-warning hover:opacity-80 border-warning transition-layout duration-slow`,
      light: `text-white bg-transparent border border-white hover:opacity-80 transition-layout duration-slow`,
      lightest: `text-white bg-transparent border border-white hover:opacity-80 transition-layout duration-slow`,
      white: `text-white bg-transparent border border-white hover:opacity-80 transition-layout duration-slow`,
      charcoal: `bg-transparent border text-primary hover:opacity-80 border-primary transition-layout duration-slow`,
      green: `bg-transparent border text-secondary hover:opacity-80 border-secondary transition-layout duration-slow`,
      beige: `bg-transparent border text-tertiary hover:opacity-80 transition-layout duration-slow`,
    },
  },
  disabled: `cursor-not-allowed pointer-events-none opacity-50`,
  icon: `justify-start sm:justify-between pl-midi sm:pl-mega pr-maxi`,
  border: `border`,
};

export const StyledButton = withFocusRing((props: any) => (
  <button
    {...props}
    className={clsx(
      props.className,
      "transition-presentation flex cursor-pointer flex-row items-center justify-center",
      props.colour &&
        props.layout &&
        styles.colour[props.layout] &&
        styles.colour[props.layout][props.colour]
        ? styles.colour[props.layout][props.colour]
        : props.colour && styles.colour.default[props.colour]
          ? styles.colour.default[props.colour]
          : null,
      props.icon && styles.icon,
      props.disabled && styles.disabled,
      props.height && styles.height[props.height],
      props.textSize && styles.textSize[props.textSize],
      props.border && styles.border,
    )}
  />
));

export const StyledButtonLink = withFocusRing((props: any) => (
  <Link
    {...props}
    className={clsx(
      props.className,
      "transition-presentation flex cursor-pointer flex-row items-center justify-center",
      props.colour &&
        props.layout &&
        styles.colour[props.layout] &&
        styles.colour[props.layout][props.colour]
        ? styles.colour[props.layout][props.colour]
        : props.colour && styles.colour.default[props.colour]
          ? styles.colour.default[props.colour]
          : null,
      props.icon && styles.icon,
      props.disabled && styles.disabled,
      props.height && styles.height[props.height],
      props.textSize && styles.textSize[props.textSize],
      props.border && styles.border,
    )}
  />
));
